import { downloadStarter } from 'features/challenges/slice';
import { useDispatch } from 'react-redux';

import { Button, Icon } from '@frontendmentorio/design-system-v2';

export default function DownloadStarterButton({
  challenge,
  onClick: handleClick,
}) {
  const dispatch = useDispatch();

  const handleDownloadStarter = () => {
    dispatch(downloadStarter({ id: challenge.id }));

    handleClick && handleClick();
  };

  return (
    <Button className="gap-2" level="secondary" onClick={handleDownloadStarter}>
      Download starter <Icon className="text-white" name="cloud-arrow-down" />
    </Button>
  );
}
